import { useState, useEffect } from 'react';
import { PageLoader } from '../components/common';
import { tenantApi, type Asset, type CTA } from '../lib/tenant-api';
import HomepageManagement from '../components/HomepageManagement';
import type { HomepageEditorMode } from '../components/homepage/types';

export default function HomePageConfigManagement({ mode = 'visitor' }: { mode?: HomepageEditorMode }) {
  const [assets, setAssets] = useState<Asset[]>([]);
  const [ctas, setCtas] = useState<CTA[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        // The Domain Expert app never shows CTAs or forms, so the expert editor doesn't need them.
        const [assetsResponse, ctasResponse] = await Promise.all([
          tenantApi.getAssets().catch(() => []),
          mode === 'expert' ? Promise.resolve([]) : tenantApi.getCTAs().catch(() => [])
        ]);

        setAssets(assetsResponse);
        setCtas(ctasResponse);
      } catch (error) {
        console.error('Failed to load homepage config data:', error);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, [mode]);

  if (loading) {
    return <PageLoader />;
  }

  return <HomepageManagement assets={assets} ctas={ctas} mode={mode} />;
}
